import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/performance'
import moment from 'moment'
import 'moment/locale/it'

moment.locale('it')
